import type { CSSProperties, ReactNode } from "react";
import { T } from "./theme";

export const Eyebrow = ({ children, color = T.dim }: { children: ReactNode; color?: string }) => (
  <div
    className="mono"
    style={{
      fontSize: 9.5,
      letterSpacing: "0.22em",
      color,
      textTransform: "uppercase",
      fontWeight: 500,
    }}
  >
    {children}
  </div>
);

export const Card = ({ children, style }: { children: ReactNode; style?: CSSProperties }) => (
  <div
    style={{
      background: T.panel,
      border: `1px solid ${T.edge}`,
      borderRadius: 14,
      padding: 14,
      ...style,
    }}
  >
    {children}
  </div>
);

export const Pill = ({
  children,
  color,
  bg,
}: {
  children: ReactNode;
  color: string;
  bg: string;
}) => (
  <span
    className="mono"
    style={{
      fontSize: 9,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color,
      background: bg,
      padding: "3px 8px",
      borderRadius: 999,
      fontWeight: 600,
    }}
  >
    {children}
  </span>
);
